<template>
    <div>
        <div v-if="windowWidth > 991">
            <v-container fluid v-for="(cotizacion, key) in cotizacionesOrdenadas" :key="'cotizacion-' + key" class="mx-0 px-0 py-0">
                <v-container>
                    <v-row>
                        <v-col cols="12" class="px-0">
                            <div style="background: #000; color: white;">
                                <v-container>
                                    <v-row align="center"
                                           justify="center">
                                        <v-col cols="12" lg="3">
                                            <h1 class="tituloCotizacion ml-2 mb-0">{{ cotizacion.fields.nombre }}</h1>
                                        </v-col>
                                        <v-col cols="12" lg="8">
                                            <p class="mb-0 ml-2 ml-lg-0">
                                                {{ cotizacion.fields.descripcion }}
                                            </p>
                                        </v-col>
                                        <v-col cols="12" lg="1">
                                            <p class="ml-2 mb-0 text-left text-lg-center">ID: {{cotizacion.fields.id }}</p>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </div>
                            <div class="v-data-table__wrapper ma-0" style="border-left: 1px solid #EBEBEB; border-right: 1px solid #EBEBEB;">
                                <table style="width: 100%; border-collapse: collapse; " class="v-data-table"
                                       v-for="(tipoProyecto, key) in tiposProyectoFiltrados(cotizacion.id)"
                                       :key="'tipoProyecto-' + key">
                                    <thead>
                                    <tr v-if="key === 0">
                                        <th>Tipo de Proyecto</th>
                                        <th>Proyecto</th>
                                        <th>Descripción</th>
                                        <th>Conceptos</th>
                                        <th v-if="!presentacion.fields.sinDesglosePrecios">Precio</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr
                                        :class="tiposProyectoFiltrados(cotizacion.id).length - 1 !== key ? 'border_bottom' : ''"
                                        v-for="(proyecto, key) in proyectosFiltrados(cotizacion.id, tipoProyecto.id)"
                                        :key="'proyecto-' + key">
                                        <td valign="top" width="10%">
                                            <p>{{ tipoProyecto.fields.nombre }}</p>
                                        </td>
                                        <td valign="top" width="15%">
                                            <p><b>{{ proyecto.fields.nombre }}</b></p>
                                        </td>
                                        <td valign="top" width="25%">
                                            <p>{{ proyecto.fields.descripcion }}</p>
                                        </td>
                                        <td valign="top" width="35%">
                                            <div v-for="(tipoProducto, key) in tiposProductosFiltrados(proyecto.id)"
                                                 :key="'tipoProducto' + key">
                                                <p class="mb-0"
                                                   v-for="(producto, key) in productosFiltrados(proyecto.id, tipoProducto.id)"
                                                   :key="'producto' + key">
                                                    {{ producto.fields.nombre }}: <b>{{ conceptosFiltrados(proyecto.id, producto.id).map(concepto => concepto.fields.nombre).join(", ") }}</b>
                                                </p>
                                            </div>
                                        </td>
                                        <td valign="top" width="15%" align="right" v-if="!presentacion.fields.sinDesglosePrecios">
                                            <p>{{ formatPrice(proyecto.fields.precio_final) }}</p>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div style="background: #000; color: white;">
                                <v-container>
                                    <v-row align="center"
                                           justify="center">
                                        <v-col cols="12" lg="9">
                                            <p class="mb-0">Condiciones:</p>
                                            <small v-for="(condicion, key) in condicionesFiltradas(cotizacion.id)"
                                                   :key="'condicion' + key" class="mb-0">
                                                * {{ condicion.fields.descripcion }} <br />
                                            </small>
                                        </v-col>
                                        <v-col cols="12" lg="3">
                                            <table style="width: 100%">
                                                <tbody>
                                                <tr v-if="!presentacion.fields.sinDesglosePrecios">
                                                    <td align="right">Valor Total: </td>
                                                    <td align="right">{{ formatPrice(cotizacion.fields.valor_final) }}</td>
                                                </tr>
                                                <tr class="font-weight-bold" style="font-size: 105%;">
                                                    <td align="right">Sub Total: </td>
                                                    <td align="right">{{ formatPrice(cotizacion.fields.precio_final) }}</td>
                                                </tr>
                                                <tr>
                                                    <td align="right">IVA: </td>
                                                    <td align="right">{{ formatPrice(cotizacion.fields.iva) }}</td>
                                                </tr>
                                                <tr>
                                                    <td align="right">Gran Total: </td>
                                                    <td align="right">{{ formatPrice(cotizacion.fields.granTotal) }}</td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </div>
                        </v-col>
                    </v-row>
                </v-container>
                <v-row v-if="cotizacionesOrdenadas.length - 1 !== key">
                    <v-col>
                        <Divider />
                        <Divider up="true" />
                    </v-col>
                </v-row>
            </v-container>
        </div>
        <div v-else>
            <v-container fluid v-for="(cotizacion, key) in cotizacionesOrdenadas" :key="'cotizacion-' + key" class="mx-0 px-0 py-0">
                <v-row>
                    <v-col cols="12">
                        <div style="background: #000; color: white;">
                            <v-container>
                                <v-row align="center"
                                       justify="center">
                                    <v-col cols="12">
                                        <h1 class="tituloCotizacion ml-2 mb-0">{{ cotizacion.fields.nombre }}</h1>
                                        <p class="ml-2 mb-0 text-left text-lg-center">ID: {{cotizacion.fields.id }}</p>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </div>
                    </v-col>
                    <v-col cols="12" class="py-0">
                        <v-container fluid class="py-0">
                            <v-row>
                                <v-col cols="12" class="py-0">
                                    <v-container fluid class="px-0 py-0">
                                        <v-row v-for="(tipoProyecto, key) in tiposProyectoFiltrados(cotizacion.id)"
                                               :key="'tipoProyecto-' + key">
                                            <table
                                                :class="tiposProyectoFiltrados(cotizacion.id).length - 1 !== key ? 'brdr_bottom' : ''"
                                                v-for="(proyecto, key) in proyectosFiltrados(cotizacion.id, tipoProyecto.id)"
                                                   :key="'proyecto-' + key">
                                                <tr>
                                                    <td class="text-left">
                                                        <p class="ml-2 mb-0 font-weight-bold">{{ proyecto.fields.nombre }}</p>
                                                    </td>
                                                    <td width="40%" class="text-right" v-if="!presentacion.fields.sinDesglosePrecios">
                                                        <p class="mr-2 mb-0">{{ formatPrice(proyecto.fields.precio_final) }}</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <p class="mb-0 ml-2">{{ proyecto.fields.descripcion }}</p>
                                                    </td>
                                                    <td></td>
                                                </tr>
                                            </table>
                                        </v-row>

                                    </v-container>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" class="px-0 py-0 my-0">
                                    <div style="background: #000; color: white;">
                                        <v-container class="py-0 my-0" fluid>
                                            <v-row align="center"
                                                   justify="center">
                                                <v-col cols="12" lg="3">
                                                    <table style="width: 100%">
                                                        <tbody>
                                                        <tr v-if="!presentacion.fields.sinDesglosePrecios">
                                                            <td align="right">Valor Total: </td>
                                                            <td align="right">{{ formatPrice(cotizacion.fields.valor_final) }}</td>
                                                        </tr>
                                                        <tr class="font-weight-bold" style="font-size: 105%;">
                                                            <td align="right">Sub Total: </td>
                                                            <td align="right">{{ formatPrice(cotizacion.fields.precio_final) }}</td>
                                                        </tr>
                                                        <tr>
                                                            <td align="right">IVA: </td>
                                                            <td align="right">{{ formatPrice(cotizacion.fields.iva) }}</td>
                                                        </tr>
                                                        <tr>
                                                            <td align="right">Gran Total: </td>
                                                            <td align="right">{{ formatPrice(cotizacion.fields.granTotal) }}</td>
                                                        </tr>
                                                        </tbody>
                                                    </table>
                                                </v-col>
                                                <v-col cols="12" lg="9">
                                                    <p class="mb-0 font-weight-bold">Condiciones:</p>
                                                    <p v-for="(condicion, key) in condicionesFiltradas(cotizacion.id)"
                                                           :key="'condicion' + key" class="minLineHeight">
                                                        * {{ condicion.fields.descripcion }} <br />
                                                    </p>
                                                </v-col>
                                            </v-row>
                                        </v-container>
                                    </div>
                                </v-col>
                            </v-row>
                        </v-container>
                        <v-row v-if="cotizacionesOrdenadas.length - 1 !== key">
                            <v-col>
                                <Divider />
                                <Divider up="true" />
                            </v-col>
                        </v-row>

                    </v-col>
                </v-row>
            </v-container>
        </div>

    </div>
</template>

<script>
import {mapState, mapGetters} from 'vuex';
import Divider from "@/components/Divider";


export default {
    name: "Lista",
    components: {Divider},
    computed: {
        ...mapState(['presentacion']),
        ...mapGetters(['cotizacionesOrdenadas',
            'tiposProyectoFiltrados',
            'proyectosFiltrados',
            'tiposProductosFiltrados',
            'productosFiltrados',
            'conceptosFiltrados',
            'condicionesFiltradas',
        ]),
        windowWidth() {
            return window.innerWidth;
        }
    },
    methods: {}
}
</script>

<style scoped>
tr.border_bottom td {
    border-bottom: 2px solid #CCC;
    padding-bottom: 10px;
    padding-top: 10px;
}

tr.border_bottom th {
    border-bottom: 2px solid #666;
    padding-bottom: 10px;
    padding-top: 10px;
}

.brdr_bottom {
    border-bottom: 1px solid #999;
    padding-bottom: 10px;
    padding-top: 10px;
}

.tituloCotizacion {
    font-family: "Bebas Neue", sans-serif;
    font-size: 150% !important;
    color: white !important;
    background: black;
    line-height: 1.1;
}

.precios {
    font-family: "Expressway Rg", sans-serif;
    font-size: 120% !important;
    color: white !important;
    background: black;
}

.contenedorTipoProyecto {
    margin: 0 !important;
    padding: 0 !important;
}

.minLineHeight {
    font-size: 80%;
    line-height: .90rem !important;
    margin-bottom: 2px;
}
</style>
